<template>
  <scoped>
    <SupplierToolbar
      v-model:value="supplierInput"
      @update="update()"
      @reset="reset()"
    />
    <SupplierList
      v-if="supplierResponse"
      v-model:selectedIndex="selectedIndex"
      :items="supplierResponse.records"
      @select="select()"
    />
    <Paginator
      v-if="supplierResponse"
      v-model:currentPage="supplierInput.plot.page"
      :itemTotal="supplierResponse.recordsTotal"
      :pageItems="supplierInput.plot.items"
      @update="update()"
    />
    <ErrorModal
      v-if="error"
      v-model:error="error"
    />
  </scoped>
</template>

<script setup lang="ts">
  import SupplierList from "@/components/lists/supplier.vue"
  import SupplierToolbar from "@/components/toolbars/supplier.vue"
  import {nextTick, onBeforeMount, PropType, ref} from "vue"
  import {
    Supplier,
    SupplierInput,
    SupplierResponse
  } from "@/endpoints/rutsolve/gql/generated/graphql"
  import Paginator from "@/components/paginator.vue"
  import {Supplier as SupplierClient} from "@/endpoints/rutsolve/gql/resolvers/supplier"
  import {SupplierSelector as Storage} from "@/storage/supplier_selector"
  import ErrorModal from "@/components/modals/error.vue"

  const value = defineModel("value", {
    default: null,
    required: false,
    type: Object as PropType<Supplier>
  })

  const emits = defineEmits([
    "select",
  ])

  const error = ref<Error>(null)
  const supplierClient = new SupplierClient()
  const supplierResponse = ref<SupplierResponse>(null)
  const supplierInput = ref<SupplierInput>(null)
  const selectedIndex = ref<number>(null)

  onBeforeMount( () => {
    read()
  })

  function update() {
    Storage.writeSupplierInput(supplierInput.value)
    read()
  }

  async function select() {
    const selectedSupplier = supplierResponse.value.records[selectedIndex.value]
    value.value = selectedSupplier
    Storage.writeSelectedSupplierID(selectedSupplier.id)
    await nextTick()
    emits("select")
  }

  function reset() {
    Storage.deleteSupplierInput()
    Storage.deleteSelectedSupplierID()
    selectedIndex.value = null
    value.value = null
    read()
  }

  async function read() {
    try {
      const storedSupplierInput = Storage.readSupplierInput()
      supplierInput.value = structuredClone(storedSupplierInput)
      supplierResponse.value = await supplierClient.selector(storedSupplierInput)
      if (!supplierResponse.value || !supplierResponse.value.records) {
        return
      }
      const storedSelectedSupplierID = Storage.readSelectedSupplierID()
      for (const [index, supplier] of supplierResponse.value.records.entries()) {
        if (supplier.id == storedSelectedSupplierID) {
          selectedIndex.value = index
          value.value = supplier
          break
        }
      }
    } catch(e) {
      error.value = e
    }
  }
</script>
